// The leave guard (spec/dashboard.md section 4.6): one `beforeunload` listener for the app; while any registered source in
// leaveGuardRegistry.ts holds unsaved work (workspace drafts, unsaved script buffers) the browser shows its own "Leave site?"
// prompt.
import { useEffect } from 'react';
import { anyDirty } from './leaveGuardRegistry';

export function LeaveGuard() {
  useEffect(() => {
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!anyDirty()) return;
      e.preventDefault();
      // older browsers show the prompt only when returnValue is set
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);
  return null;
}
